import { SelectErrorIndicator, SelectLoadingIndicator } from '@wyz/ui';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectField } from '~/common/components';
import { Trans } from '~/common/context';
import { useManageCustomerGroups } from '~/connect/api';

export const CustomerGroupSelectField: React.FC<{
  label?: React.ReactNode;
  required?: boolean;
  isClearable?: boolean;
  readOnly?: boolean;
}> = ({
  label = <Trans i18nKey='app.entity.form.customer_group' />,
  required = true,
  isClearable = true,
  readOnly = false,
}) => {
  const { watch, setValue } = useFormContext();
  const watchedValue = watch('customerGroup.value');
  const customerGroups = useManageCustomerGroups({ list: { enabled: true } });

  const options =
    customerGroups.data?.data?.map((group) => ({
      label: group.name,
      value: String(group.id),
    })) ?? [];

  // sync label
  useEffect(() => {
    if (watchedValue) {
      const group = customerGroups.data?.data?.find(
        (g) => String(g.id) === watchedValue,
      );
      if (group) {
        setValue('customerGroup.label', group.name);
      }
    } else {
      setValue('customerGroup.label', undefined);
    }
  }, [customerGroups.data?.data, setValue, watchedValue]);

  return (
    <>
      {customerGroups.isError && (
        <SelectErrorIndicator
          label={label}
          message={<Trans i18nKey='app.common.select_field.options_error' />}
        />
      )}
      {!customerGroups.isSettled && <SelectLoadingIndicator label={label} />}
      {customerGroups.isSuccess && (
        <SelectField
          name={'customerGroup.value'}
          label={label}
          options={options}
          isClearable={isClearable}
          isDisabled={readOnly}
          required={required}
        />
      )}
    </>
  );
};
